/* tslint:disable:no-shadowed-variable */
import camelcaseKeysDeep from 'camelcase-keys-deep'
import { ModuleNames } from '@/store/module-names'
import { PatientWithStatsState } from './types'
import { PatientWithStatsActionNames, PatientWithStatsMutationNames } from './keys'
import { getters } from './getters'
import { getPatientWithStats, getPatientWithStatsById } from '@/jsonapi/PatientWithStats'
const state: PatientWithStatsState = {
  patientWithStats: [],
}

const mutations = {
  [PatientWithStatsMutationNames.updatePatientWithStats](state: PatientWithStatsState, payload): void {
    state.patientWithStats = payload
  },
}

const actions = {
  async [PatientWithStatsActionNames.getPatientWithStatsById](
    { commit, state },
    payload: { patientId: string; startTimestamp: number; endTimestamp: number }
  ): Promise<void> {
    const results = camelcaseKeysDeep(await getPatientWithStatsById(payload))
    if (!results.length) {
      return
    }

    const clonePatientWithStatsReports = [...state.patientWithStats]
    const sameIdIndex = clonePatientWithStatsReports.findIndex(
      pWithSummaryReports => pWithSummaryReports.id === results[0].id
    )
    if (sameIdIndex >= 0) {
      clonePatientWithStatsReports.splice(sameIdIndex, 1, results[0])
    } else {
      clonePatientWithStatsReports.push(results[0])
    }
    commit(PatientWithStatsMutationNames.updatePatientWithStats, clonePatientWithStatsReports)
  },
  async [PatientWithStatsActionNames.getPatientWithStats](
    { commit, state },
    payload: { startTimestamp: number; endTimestamp: number }
  ): Promise<void> {
    const results = camelcaseKeysDeep(await getPatientWithStats(payload))
    commit(PatientWithStatsMutationNames.updatePatientWithStats, results)
  },
}

export default {
  name: ModuleNames.patientWithStats,
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
